import React, { useCallback, useEffect, useState } from "react";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { formValueSelector, reduxForm } from "redux-form";
import { Container } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import ShowMap from "../../components/ViewTracking/GoogleMap/ShowMap";
import OrderStatus from "../../components/OrderStatus/OrderStatus";
import ProviderDetails from "../../components/ProviderDetails/ProviderDetails";
import BillingDetails from "../../components/BillingDetails/BillingDetails";
import PaymentCompleted from "../../components/PaymentCompleted/PaymentCompleted";
import CommonModal from "../../components/Modal/CommonModal";
import AdditionalRequestForm from "../../components/AdditionalRequestForm/AdditionalRequestForm";
import ViewTrackingSkeleton from "../../components/Skeleton/ViewBooking/ViewTrackingSkeleton/ViewTrackingSkeleton";

import { openHeaderModal, closeHeaderModal } from "../../actions/siteadmin/modalActions";
import history from "../../history";
import messages from "../../locale/messages";
import SocketContext from "../../core/socketNotifications/SocketContext";

import { AngleLeftArrowIcon } from "../../components/Common/Assets/SVGIcon/CommonSvgIcon";

import bt from '../../components/commonStyle.css';
import s from './ViewTracking.css';



function ViewTracking({ id, intl: { formatMessage } }) {

    const [load, setLoad] = useState(false);
    const [isSmallDevice, setIsSmallDevice] = useState(false);
    const dispatch = useDispatch()
    useEffect(() => {
        setLoad(true)
    }, [])

    const selector = formValueSelector('ViewTracking')
    const bookingDetails = useSelector(state => state?.bookingDetails?.data)
    const mapRouteDirections = useSelector(state => selector(state, 'mapRouteDirections'))
    const mapMarkerPoints = useSelector(state => selector(state, 'mapMarkerPoints'))
    const sw_lat = useSelector(state => selector(state, 'sw_lat'))
    const sw_lng = useSelector(state => selector(state, 'sw_lng'))
    const ne_lat = useSelector(state => selector(state, 'ne_lat'))
    const ne_lng = useSelector(state => selector(state, 'ne_lng'))
    const additionalRequest = useSelector(state => state?.adminModalStatus?.additionalRequest)

    const handleClick = () => {
        history.push({
            pathname: history?.location?.state?.from ? history?.location?.state?.from : '/dashboard',
            state: { from: history.location.pathname }
        });
    };

    const handleResizeHandler = useCallback(() => {
        setIsSmallDevice(window.matchMedia('(max-width: 767px)').matches);
    }, []);

    useEffect(() => {
        const isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
            handleResizeHandler();
            window.addEventListener('resize', handleResizeHandler);
        }

        return () => {
            window.removeEventListener('resize', handleResizeHandler);
        };
    }, [handleResizeHandler]);

    const isBookingCompleted = bookingDetails?.status === 'completed' ? true : false;
    const isPaymentCompleted = bookingDetails?.paymentStatus == 'completed' ? true : false;

    const closeAdditionalModal = () => {
        if (bookingDetails?.additionalFeeStatus === 'approved') {
            dispatch(closeHeaderModal('additionalRequest'));
        }
    }

    let formData = {
        noCloseIcon: true
    }

    !isBookingCompleted && (bookingDetails?.additionalFeeStatus === 'pending' && dispatch(openHeaderModal('additionalRequest', formData)))
    if (!load && !isBookingCompleted) {
        return <div className={'subPageContainer'}><Container><ViewTrackingSkeleton /></Container></div>
    }
    return (
        <>
            <CommonModal
                title={formatMessage(messages.additionalWorkRequest)}
                onHide={closeAdditionalModal}
                modalStatus={additionalRequest}
            >
                <AdditionalRequestForm
                    id={id}
                    fee={bookingDetails?.requestedAdditionalFee}
                    details={bookingDetails?.requestedAdditionalFeeDescription}
                    currency={bookingDetails?.currency}
                    secondDifference={bookingDetails?.secondDifference}
                    additionalWorkInterval={bookingDetails?.additionalWorkInterval}
                    data={bookingDetails}
                />
            </CommonModal>
            <SocketContext.Consumer>
                {
                    socket => (
                        <div className={'subPageContainer'}>
                            <Container>
                                {!isPaymentCompleted && !isBookingCompleted ? (
                                    <>
                                        <>
                                            <div className={cx(bt.space3)}>
                                                <div onClick={() => handleClick()} className={cx(bt.customLink, 'customLinkRtl')}>
                                                    <AngleLeftArrowIcon />
                                                    <FormattedMessage {...messages.goBackText} />
                                                </div>
                                            </div>
                                            <div className={bt.commonViewBookingContainer}>
                                                <div className={s.viewTrackingMapContainer}>
                                                    <ShowMap
                                                        mapRouteDirections={mapRouteDirections}
                                                        mapMarkerPoints={mapMarkerPoints}
                                                        height={isSmallDevice ? '365px' : '590px'}
                                                        radius="18px"
                                                        sw_lat={sw_lat}
                                                        sw_lng={sw_lng}
                                                        ne_lat={ne_lat}
                                                        ne_lng={ne_lng}
                                                    />
                                                    <div className={cx(s.viewTrackProviderDetailsBox, 'viewTrackProviderDetailsBoxRtl')}>
                                                        <ProviderDetails data={bookingDetails} socket={socket} />
                                                    </div>
                                                </div>
                                                <div className={bt.commonStickyRsContainer}>
                                                    {bookingDetails &&
                                                        <OrderStatus data={bookingDetails}
                                                            socket={socket}
                                                            id={id}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    </>
                                ) : !isPaymentCompleted ? <BillingDetails data={bookingDetails} id={id} socket={socket} isTipAmount={true} />
                                    : <PaymentCompleted data={bookingDetails} id={id} />
                                }
                            </Container>
                        </div>
                    )
                }
            </SocketContext.Consumer>
        </>
    )
}

ViewTracking = reduxForm({
    form: 'ViewTracking'
})(ViewTracking);

export default injectIntl(withStyles(bt, s)(ViewTracking))
